import { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { ColorPicker as RfColorPicker } from '@renderforest/rf-components'
import { userSelectors } from 'store/features/user/selectors'
import BackButton from 'common-components/BackButton'
import SlideUp from 'common-components/SlideUp'

import * as Styled from './styled'

interface IMobileColorPickerProps {
  isOpen: boolean
  onClose: () => void
  currentColor: string | null
  onChangeCompleted: (hexColor: string) => void
  contentHeight?: number
}

export const MobileColorPicker = memo(function MobileColorPicker(
  props: IMobileColorPickerProps
) {
  const {
    isOpen,
    onClose,
    currentColor,
    onChangeCompleted,
    contentHeight = 315
  } = props

  const isUserLoggedIn = useSelector(userSelectors.isUserLoggedIn)

  const onColorChangeCompleted = useCallback(
    (hexColor: string) => {
      onChangeCompleted(hexColor)
    },
    [onChangeCompleted]
  )

  return (
    <SlideUp isOpen={isOpen} onClose={onClose}>
      <Styled.MobileColorPickerWrapper>
        <BackButton onClick={onClose} />
        <RfColorPicker
          isDarkMode={false}
          currentColor={currentColor}
          onChangeCompleted={onColorChangeCompleted}
          isLoggedIn={isUserLoggedIn}
          contentHeight={contentHeight}
          openAuthModal={window.openRFAuthModal}
        />
      </Styled.MobileColorPickerWrapper>
    </SlideUp>
  )
})
